import { format } from 'date-fns';
import numeral from 'numeral';
import { v4 as uuid } from 'uuid';

export function string2money(value: string | number): string {
  return numeral(`${value}`).format('0,0.[00]');
}

export function string2number(value: string | number): string {
  return numeral(`${value}`).format('0,0');
}

export function money2number(value: string): number {
  return numeral(value).value();
}

export function replaceAll(str: string, find: string, replace: string) {
  return str.replace(new RegExp(find, 'g'), replace);
}

export function capitalize(value?: string | null): string {
  try {
    const words = (value || '').split(' ');
    for (let i = 0; i < words.length; i++) {
      words[i] = (words[i][0] || '').toUpperCase() + words[i].substring(1);
    }
    return words.join(' ');
  } catch {
    return '';
  }
}

export function transformLabel(value: any[], separator = ' - ') {
  return value.filter(Boolean).join(separator);
}

export function toTitleCase(str: string) {
  return str
    .split(' ')
    .map((txt) => {
      return txt.charAt(0).toUpperCase() + txt.substring(1);
    })
    .join(' ');
}

export function toSentenceCase(str: string) {
  const s =
    str
      .match(
        /[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g,
      )
      ?.join(' ') || '';
  return s.slice(0, 1).toUpperCase() + s.slice(1);
}

export function generateId() {
  return uuid();
}

export function formatDate(date: Date, formatter = 'dd-MM-yyyy') {
  try {
    return format(date, formatter);
  } catch (e) {
    return e.message;
  }
}

export function base64ToUrl(base64string: string, type?: string) {
  const byteChars = atob(base64string);

  const byteNumbers = new Array(byteChars.length);
  for (let i = 0; i < byteChars.length; i++) {
    byteNumbers[i] = byteChars.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);

  const blob = new Blob([byteArray], { type });
  const blobUrl = URL.createObjectURL(blob);

  return blobUrl;
}
